<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Πίνακας Εκτύπωσης Κλιμακίων</h4>
            <div v-if="errorMsg">
              <b-alert show dismissible variant="danger">{{
                errorMsg
              }}</b-alert>
            </div>
            <div class="col-12">
              <div class="row">
                <label class="col-md-2 mt-5">Ημερομηνίες Αλλαγής:</label>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Από</label>
                    <b-form-input id="example-input" v-model="startDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Μέχρι (Κενό: χθές)</label>
                    <b-form-input id="example-input" v-model="endDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-4">
                    <div class="mb-3">
                        <label class="mt-3">Κατηγορία Θέσης</label>
                        <multiselect v-model="trainingValue" :options="trainingOptions"
                            placeholder="Επιλέξτε Θέση" selectLabel="Eπιλογή Θέσης" selectedLabel="Επιλέχθηκε"
                            deselectLabel="Αποεπιλογή"></multiselect>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12" style="margin-top:100px;">
              <div class="row">
                <div class="col-md-2">
                  <div class="mt-2">
                    <button class="btn btn-primary">
                      Προεπισκόπηση
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { mapState, mapGetters } from "vuex";

export default {
  page: {
    title: "Κλιμάκια",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Κλιμακια",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Κλιμάκια",
          active: true,
        },
      ],

      startDate: "",
      endDate: new Date(Date.now() - 864e5).toISOString().split("T")[0],
      departmentValue: "",
      personID: "",
      signatureSelected: "",
      signaturesOptions: [],
      spinnerShow: false,
      errorMsg: "",
      printOptions: [
        { id: 0, name: "Αναλυτική κατάσταση παρουσιών" },
        { id: 1, name: "Ελλείμματα - Πλεονάσματα / Ανα Ημέρα" },
        // { id: 2, name: "Ελλείμματα - Πλεονάσματα / Ανα Περίοδο", periodic: 1 },
        { id: 6, name: "Ελλείμματα - Πλεονάσματα / Ανα Περίοδο" },
        { id: 7, name: "Ελλείμματα - Πλεονάσματα / Συνολική" },
        { id: 8, name: "Κατάσταση Ωρών Εργασίας" },
        { id: 2, name: "Περιοδική Κατάσταση", periodic: 1 },
        { id: 4, name: "Κατάσταση απόντων - Ανά Ημέρα" },
        { id: 5, name: "Κατάσταση απόντων - Ανά Περίοδο" },
      ],
      printOptionsValue: "",
      personOptionValue: "",
      peopleFilters: {
        department: "",
      },
      trainingOptions: ["ΠΕ", "ΤΕ", "ΔΕ", "ΥΕ"],
    };
  },
  computed: {
    ...mapGetters("auth", ["is_staff", "is_superuser", "userLoggedIn"]),
    ...mapState("utils", [
      "departments",
      "peopleOptionFields",
      "departmentOptions",
      "signatures",
    ]),
    // ...mapGetters("utils", ["departmentNames"]),
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    peopleOptions() {
      if (this.departmentValue && this.departmentValue.id) {
        return this.peopleOptionFields
          .filter((e) => {
            return e.department.includes(this.departmentValue.id);
          })
          .map((e) => {
            return { id: e.id, name: e.person_full_name };
          });
      } else {
        return this.peopleOptionFields.map((e) => {
          return { id: e.id, name: e.person_full_name };
        });
      }
    },
  },
  methods: {
  },
};
</script>
